// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3o-KzHnX0EH4J3OAaSlHO7{grid-template-areas:\"current-title new-title\" \"current-text1 new-text1\" \"current-text2 new-text2\" \"current-text3 new-text3\"}._2Srs1FW7VemNe4Av7BLZCH{grid-area:current-title}._3LxRoUkkVWWWx8mmNgSGUz{grid-area:current-text1}._2bf7p6F6KR7qllRlcl-Zuq{grid-area:current-text2}._1v6edHF7QJiwt2RSzPOwJJ{grid-area:current-text3}._3EWyOMhyWlbawr5aAGLqkw{grid-area:new-title}.HNEWQIJLjZPOfZgmmL-s{grid-area:new-text1}._3YEGxbORhfOiFyA-W4QCYY{grid-area:new-text2}.VjeTa-bhmoIVDc4ApZCP9{grid-area:new-text3}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridTemplateArea": "_3o-KzHnX0EH4J3OAaSlHO7",
	"gridAreaCurrentTitle": "_2Srs1FW7VemNe4Av7BLZCH",
	"gridAreaCurrentText1": "_3LxRoUkkVWWWx8mmNgSGUz",
	"gridAreaCurrentText2": "_2bf7p6F6KR7qllRlcl-Zuq",
	"gridAreaCurrentText3": "_1v6edHF7QJiwt2RSzPOwJJ",
	"gridAreaNewTitle": "_3EWyOMhyWlbawr5aAGLqkw",
	"gridAreaNewText1": "HNEWQIJLjZPOfZgmmL-s",
	"gridAreaNewText2": "_3YEGxbORhfOiFyA-W4QCYY",
	"gridAreaNewText3": "VjeTa-bhmoIVDc4ApZCP9"
};
module.exports = ___CSS_LOADER_EXPORT___;
